import { citiesByCountry, type Country } from "./photographers";

export type CityInfo = {
  slug: string;
  name: string;
  country: Country;
};

function slugify(s: string): string {
  return s
    .toLowerCase()
    .replace(/ä/g, "ae")
    .replace(/ö/g, "oe")
    .replace(/ü/g, "ue")
    .replace(/ß/g, "ss")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export const cities: CityInfo[] = (Object.keys(citiesByCountry) as Country[]).flatMap(
  (country) =>
    citiesByCountry[country].map((name) => ({
      slug: slugify(name),
      name,
      country,
    })),
);

export const citiesBySlug: Record<string, CityInfo> = Object.fromEntries(
  cities.map((c) => [c.slug, c]),
);

export function findCityBySlug(slug: string): CityInfo | undefined {
  return citiesBySlug[slug];
}

/**
 * Match a photographer's city/region field to a city name.
 * Handles slight variations like "Berlin Mitte" → "Berlin".
 */
export function photographerMatchesCity(
  photographerCity: string | null | undefined,
  cityName: string,
): boolean {
  if (!photographerCity) return false;
  const a = photographerCity.toLowerCase();
  const b = cityName.toLowerCase();
  return a === b || a.startsWith(b + " ") || a.includes(b);
}

/**
 * SEO intro copy per city. Falls back to a generic template.
 */
export function cityIntro(city: CityInfo): string {
  return `Kuratierte Fotografen in ${city.name}, Portrait, Hochzeit, Produkt und freie Arbeiten. OM Selected empfiehlt geprüfte Fotografen aus ${city.name} und Umgebung. Kein Marktplatz, kein Algorithmus, eine redaktionelle Auswahl.`;
}